import Reflux from 'reflux';

export default Reflux.createActions([
  'fetchReleases',
  'fetchReleasesError',
  'fetchReleasesSuccess',
]);
